import { Trans, useTranslation } from 'react-i18next'
import { useState } from 'react'

import { AcknowledgeModal, ActionModal, Modal } from '@percent/lemonade'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useMutation } from '@percent/partner-dashboard/common/hooks'
import { FeatureOpportunityModalProps } from './FeatureOpportunityModalProps.types'

export function RemoveFeatureOpportunityModal({
  isOpen,
  onClose,
  refresh,
  opportunity
}: Readonly<FeatureOpportunityModalProps>) {
  const { t } = useTranslation()
  const { workplaceGivingService } = useServices()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)

  const [{ isLoading }, { apiFunc: removeFeaturedFundraiser }] = useMutation(
    workplaceGivingService.removeFeaturedItem,
    () => {
      setIsSuccess(true)
      refresh()
    },
    () => {
      setIsError(true)
    }
  )

  const handleRemoveFeaturedFundraiser = () => {
    removeFeaturedFundraiser(opportunity.featuredItemId!)
  }

  const handleCloseSuccessModal = () => {
    setIsSuccess(false)
    onClose()
  }

  const handleCloseErrorModal = () => {
    setIsError(false)
    onClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      {!isSuccess && !isError && (
        <Modal
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="open-remove-featured-opportunity"
          data-testid='"open-remove-featured-opportunity'
        >
          <ActionModal
            title={t('dialog.volunteering.remove.title')}
            primaryButtonText={t('button.remove')}
            secondaryButtonText={t('button.cancel')}
            handleClose={handleClose}
            handleSubmit={handleRemoveFeaturedFundraiser}
            loading={!!isLoading}
            primaryBtnTestId="btn-remove-featured-opportunity"
            disabled={!!isLoading}
          >
            <Trans
              i18nKey="dialog.volunteering.remove.description"
              components={{ b: <b /> }}
              values={{ opportunityName: opportunity.name }}
            />
          </ActionModal>
        </Modal>
      )}
      <Modal
        open={isSuccess}
        onClose={handleCloseSuccessModal}
        aria-labelledby="open-removed-opportunity-success"
        data-testid="open-removed-opportunity-success"
      >
        <AcknowledgeModal
          result="positive"
          title={t('dialog.volunteering.remove.success.title')}
          description={t('dialog.volunteering.remove.success.description', {
            opportunityName: opportunity.name
          })}
          buttonText={t('button.close')}
          handleClose={handleCloseSuccessModal}
          buttonTestId="success-modal-btn"
        />
      </Modal>
      <Modal
        open={isError}
        onClose={handleCloseErrorModal}
        aria-labelledby="open-removed-opportunity-error"
        data-testid="open-removed-opportunity-error"
      >
        <AcknowledgeModal
          result="negative"
          title={t('dialog.volunteering.remove.error.title')}
          description={t('dialog.error.description')}
          buttonText={t('button.close')}
          handleClose={handleCloseErrorModal}
          buttonTestId="error-modal-btn"
        />
      </Modal>
    </>
  )
}
